function getRandomColor() {
  // Genera un número aleatorio entre 0 y 16777215 (0xFFFFFF)
  const randomColor = Math.floor(Math.random() * 16777215);

  // Convierte el número a una cadena hexadecimal y lo rellena con ceros a la izquierda si es necesario
  return `#${randomColor.toString(16).padStart(6, "0")}`;
}

export default getRandomColor;